import User from '@common/types/user/user';

export const isAddressReady = (userProfile: Partial<User>) => {
  return !!(
    userProfile.address &&
    userProfile.address.country &&
    userProfile.address.country.id &&
    userProfile.address.state &&
    userProfile.address.city &&
    userProfile.address.address
  );
};
